'use client'

// React Imports
import type { ReactNode } from 'react'

// MUI Imports
import Zoom from '@mui/material/Zoom'
import { styled } from '@mui/material/styles'
import useScrollTrigger from '@mui/material/useScrollTrigger'

import { verticalLayoutClasses } from '@layouts/utils/layoutClasses'

interface ScrollToTopProps {
  className?: string
  children: ReactNode
}

const ScrollToTopStyled = styled('div')(({ theme }) => ({
  zIndex: 'var(--mui-zIndex-fab)',
  position: 'fixed',
  insetInlineEnd: theme.spacing(10),
  insetBlockEnd: theme.spacing(18)
}))

const ScrollToTop = (props: ScrollToTopProps) => {
  // Props
  const { children, className } = props

  // Hooks
  // init trigger
  const targetElement =
    typeof window !== 'undefined'
      ? (document.querySelector(`.${verticalLayoutClasses.content}`) as Element | null)
      : null

  const isScrollable =
    !!targetElement &&
    typeof (targetElement as any).scrollHeight === 'number' &&
    (targetElement as any).scrollHeight > (targetElement as any).clientHeight

  const trigger = useScrollTrigger({
    threshold: 400,
    disableHysteresis: true,
    target: isScrollable ? targetElement ?? undefined : undefined
  })

  const handleClick = () => {
    const anchor =
      (isScrollable ? targetElement : null) ??
      (typeof window !== 'undefined' ? document.scrollingElement || document.documentElement : null)

    if (anchor) {
      // @ts-ignore
      if (anchor.scrollTo) {
        // @ts-ignore
        anchor.scrollTo({ top: 0, behavior: 'smooth' })
      } else {
        // Fallback
        // @ts-ignore
        anchor.scrollTop = 0
      }
    }
  }

  return (
    <Zoom in={trigger}>
      <ScrollToTopStyled className={className} onClick={handleClick} role='presentation'>
        {children}
      </ScrollToTopStyled>
    </Zoom>
  )
}

export default ScrollToTop
